export default "__VITE_ASSET__BuwgyRI9__"